import { render } from "./GlassBallParticleScreen.vue?vue&type=template&id=3933f5c0&scoped=true&ts=true"
import script from "./GlassBallParticleScreen.vue?vue&type=script&lang=ts"
export * from "./GlassBallParticleScreen.vue?vue&type=script&lang=ts"

import "./GlassBallParticleScreen.vue?vue&type=style&index=0&id=3933f5c0&scoped=true&lang=css"

import exportComponent from "D:\\DDrive\\DeveloperFolder\\VueJsApps\\byihusemanagt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3933f5c0"]])

export default __exports__